import { getApplyData } from '@/api/apply';

const state = {
  hasApplyData: false,
  lastFetchTime: null
};

const mutations = {
  SET_HAS_APPLY_DATA(state, hasData) {
    state.hasApplyData = hasData;
  },
  SET_LAST_FETCH_TIME(state, time) {
    state.lastFetchTime = time;
  }
};

const actions = {
  async fetchApplyData({ commit, state }) {
    const now = Date.now();
    if (state.lastFetchTime && (now - state.lastFetchTime) < 5 * 60 * 1000) {
      return;
    }

    try {
      const { data } = await getApplyData();
      const hasData = data && data.jobs && data.jobs.length > 0;
      commit('SET_HAS_APPLY_DATA', hasData);
      commit('SET_LAST_FETCH_TIME', now);
    } catch (error) {
    //   console.error('获取报名数据失败:', error);
      commit('SET_HAS_APPLY_DATA', false);
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/apply.js